import React from "react";
import { Link } from "gatsby";

export interface MenuNotFoundProps {
  lang: "en" | "zh";
}

/**
 * Menu on 404 page
 */
const MenuNotFound = ({ lang }: MenuNotFoundProps) => {
  return (
    <ul className="text-md text-lucid-300 mb-5 list-disc ml-5">
      <li>
        <Link lang={lang}
              to="/inquiry"
              title="Menu item Inquiry"
        >Inquiry</Link>
      </li>
      <li>
        <Link to="/about"
              title="Menu item About"
        >
          About us
        </Link>
      </li>
      <li>
        <Link to="/contact"
              title="Menu item Contact"
        >
          Contact
        </Link>
      </li>
      <li>
        <Link to="/blog"
              title="Menu item Blog"
        >
          Blog
        </Link>
      </li>
    </ul>
  );
};

export default MenuNotFound;
